'use strict';

document.addEventListener('DOMContentLoaded', function () {
  // Skip animations when Shopify Theme Editor is active
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('m-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -48px 0px'
  });

  document.querySelectorAll('.m-animate-up').forEach(function (el) {
    observer.observe(el);
  });
});
